import { registerQuery, useSuspenseQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import {
  AppPermissionTranslationItem,
  getAppPermissionTranslationsRpc,
} from '../../../../../__generated__/chirp/com/hubspot/app/permissions/hublets/app/auth/rpc/AppPermissionsHubletsAppAuthRpc';
import { rpcClient } from '../../../../shared/rpc-client';

const GET_APP_PERMISSION_TRANSLATIONS = registerQuery({
  fieldName: 'appPermissionTranslations',
  args: ['appPermissionNames'],
  fetcher: ({ appPermissionNames }: { appPermissionNames: string[] }) => {
    if (appPermissionNames.length === 0) {
      return new Map<string, AppPermissionTranslationItem>();
    }
    return rpcClient
      .call(getAppPermissionTranslationsRpc, {
        request: {
          appPermissionNames,
        },
      })
      .then((response) => {
        const translationMap: Map<string, AppPermissionTranslationItem> =
          response.translations.reduce((acc, translation) => {
            acc.set(translation.appPermissionName, translation);
            return acc;
          }, new Map<string, AppPermissionTranslationItem>());
        return translationMap;
      })
      .catch((e) => {
        Raven.captureException(e, {
          extra: {
            message:
              'Error fetching app permission translations, returning empty map!',
            appPermissionNames,
          },
        });
        // Return an empty map instead of throwing an error since this is not a critical error and we want to avoid blocking the UI.
        return new Map<string, AppPermissionTranslationItem>();
      });
  },
});

export const useGetAppPermissionTranslations = (
  appPermissionNames: string[]
) => {
  return useSuspenseQuery(GET_APP_PERMISSION_TRANSLATIONS, {
    variables: { appPermissionNames },
  }).data.appPermissionTranslations;
};
